import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/hooks/useDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import BussEstSettingsContent from './BussEstSettingsContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const INIT_FILTER = {
  sort_by: 'desc',
  q: '',
};

function BussEstSettingsContainer({
  match,
  history,
  getBusinessEstablishmentsList,
  establishmentList,
  isLoading,
  removeFixTax,
  establishmentListPager,
  getSingleBussEst,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getBusinessEstablishmentsList(debouncedFilter);

    return () => {
      setModal({ isOpen: false });
    };
  }, [JSON.stringify(debouncedFilter)]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Business Establishment',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Business Establishment',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this business establishment?',
      () => {
        removeFixTax(data.id, () => {
          getBusinessEstablishmentsList(INIT_FILTER);
          const id = _.get(establishmentList, '0.id');
          history.push(`${id}`);
          getSingleBussEst(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:establishmentId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Business Establishments"
            // getData={getBusinessEstablishmentsList}
            // setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search..."
            listName="fixTax"
            label="Business Establishment"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.name')}</div>
            )}
            isLoading={isLoading}
            selected={params.establishmentId}
            data={establishmentList}
            dataPager={establishmentListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:establishmentId?`}
                    render={() => (
                      <BussEstSettingsContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:establishmentId?`}
                  render={() =>
                    !params.establishmentId && establishmentList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(establishmentList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

BussEstSettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBusinessEstablishmentsList: PropTypes.instanceOf(Function).isRequired,
  establishmentList: PropTypes.instanceOf(Array).isRequired,
  establishmentListPager: PropTypes.instanceOf(Object).isRequired,
  removeFixTax: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleBussEst: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  establishmentList: _.get(api, `${c.GET_BUSINESS_EST}.list`) || [],
  establishmentListPager: _.get(api, `${c.GET_BUSINESS_EST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_BUSINESS_EST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BussEstSettingsContainer);
